import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from 'shared/components/FloatingLabel';

import { verifiedByCianSelector } from './selectors';

export function VerifiedByCianLabelContainer() {
  const isVerifiedByCian = useSelector(verifiedByCianSelector);

  if (!isVerifiedByCian) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="VerifiedByCianLabel"
      labelText="Проверено Циан"
      tooltipText="Убедились, что информация в объявлении верна — оценили видео, фото объекта или дополнительно проанализировали объявление"
      color="accent-main-primary"
      backgroundColor="accent-main-secondary"
      icon={<IconProductTrust16 color="icon-main-default" />}
      link="https://support.cian.ru/ru/knowledge_base/article/7516/category/463"
      linkText="Подробнее"
    />
  );
}
